import React from 'react';
import { useDesignMode } from '../../contexts/DesignContext';
import { classNames } from '../../utils/classNames';

interface SketchPageTitleProps {
  as?: 'h1' | 'h2' | 'h3';
  className?: string;
  children: React.ReactNode;
  'data-testid'?: string;
}

export const SketchPageTitle: React.FC<SketchPageTitleProps> = ({
  as: Tag = 'h1',
  className,
  children,
  'data-testid': testId,
}) => {
  const { isSketchy } = useDesignMode();

  return (
    <Tag
      data-testid={testId}
      className={classNames(
        'font-bold text-[var(--color-text)]',
        isSketchy ? 'scribble-underline inline-block text-3xl sm:text-4xl' : 'text-3xl',
        className
      )}
    >
      {children}
    </Tag>
  );
};
